import { importPromise } from '~/lib/projects/importStore';
import { withResolvers } from '~/utils/promises';

const NEVER = withResolvers<void>();

export const figmaImportStore = {
  fetch: withResolvers<void>(),
  generate: withResolvers<void>(),
};

export function waitForFigmaFetch() {
  return Promise.race([figmaImportStore.fetch.promise, importPromise.promise.then(() => NEVER.promise)]);
}

export function waitForFigmaGenerate() {
  return Promise.race([figmaImportStore.generate.promise, importPromise.promise.then(() => NEVER.promise)]);
}
